import { useSignupStep } from '@/app/(auth)/signup/components/signupStep/SignupStepContext';

export function useIsFixUp() {
  const signup = useSignupStep();

  return !!signup.details.isFixingUp;
}
